.capacity-subscription-charge {
  height: 100%;
  overflow-y: auto;
}
.capacity-subscription-charge .layout__container__page__content {
  padding: 24px;
  background: #f0f2f5;
}
